export default __webpack_public_path__ + "static/Stimberry-fb24ea862d6fc826168618c1d0522295.png";